import { render, staticRenderFns } from "./dangerousGoodsRow.vue?vue&type=template&id=cc2cef12"
import script from "./dangerousGoodsRow.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports